import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
// import ThemeButton from './Element/ThemeButton/ThemeButton';

import Homepage from "./Pages/Homepage";
import Contact from "./Pages/Contact";

import ScrollToTop from "./Element/ScrollToTop";

import Impressum from "./Pages/Impressum";
import Datenschutz from "./Pages/Datenschutz";

import Header from "./Layout/Header";
import Footer from "./Layout/Footer";

class Markup extends Component {
    render() {
        return (
            <BrowserRouter basename="/">
                <div className="page-wrapper">
                    <Header />
                    <Switch>
                        <Route path="/" exact component={Homepage} />
                        <Route path="/contact" exact component={Contact} />
                        <Route path="/impressum" exact component={Impressum} />
                        <Route path="/datenschutz" exact component={Datenschutz} />
                    </Switch>
                    <Footer />
                </div>
                <ScrollToTop />
                {/* <ThemeButton /> */}
            </BrowserRouter>
        );
    }
}

export default Markup;
